import React from 'react';
import { Card } from 'react-bootstrap';
import projImg1 from "../../assets/img/1.png";
import projectimage1 from "../../assets/img/p1.png";
import ShowMoreText from "react-show-more-text";


// Begin: Component code
const Beatrix_Sellei_psychology_academic = () => {
    // Your component logic here
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={projectimage1} />
        <br />
        <Card.Body>
          <Card.Text>
            
            {" "}
            <img className="img2" src={projImg1} />{" "}
            <p className="text7">Beatrix Séllei</p>
            <br />
            <p className="text8">
            Assistant Professor
              <br />
              Department of Ergonomics and Psychology, BME{" "}
            </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
              The research topic aims to investigate the effects of
              positive psychological characteristics behind successful
              performance using mathematical methods. The primary area of
              research is the examination of predictions using machine
              learning methodology to filter out human attributes that
              influence performance. This kind of modelling of success
              enables optimal organizational human resource planning and
              development. The research area combines the results of the
              humanities with the field of data sciences using
              mathematical tools.
              <br />
              <br />
              Recommended literature:{" "}
              <ul>
                <li>
                  Séllei, B., Stumphauser, N., & Molontay, R. (2021).
                  Traits versus Grades—The Incremental Predictive Power of
                  Positive Psychological Factors over Pre-Enrollment
                  Achievement Measures on Academic Performance.
                  <span className="text9"> Applied Sciences </span>, 11(4),
                  1744.{" "}
                </li>
                <li>
                  Richardson, M., Abraham, C., & Bond, R. (2012).
                  Psychological correlates of university students'
                  academic performance: a systematic review and
                  meta-analysis.
                  <span className="text9"> Psychological bulletin </span>,
                  138(2), 353.{" "}
                </li>
                <li>
                  Martínez, I. M., Youssef-Morgan, C. M., Chambel, M. J.,
                  & Marques-Pinto, A. (2019). Antecedents of academic
                  performance of university students: Academic engagement
                  and psychological capital resources.
                  <span className="text9"> Educational Psychology </span>,
                  39(8), 1047-1067.
                </li>
              </ul>
            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};
// End: Component code

export default Beatrix_Sellei_psychology_academic;
